const carrier = {
  path: '/carrier',
  name: 'business',
  icon: 'iconweibiaoti-4',
  redirect: '/carrier/incubator',
  component: () => import('@/pages/layout/appMain'),
  children: [
    // 保温箱
    {
      icon: 'icon-weibolu-xian',
      name: 'incubator',
      path: '/incubator',
      component: () => import('@/pages/business/incubator')
    },
    // 冰箱
    {
      icon: 'el-icon-coffee-cup',
      name: 'fridge',
      path: '/refrigerator',
      component: () => import('@/pages/business/refrigerator')
    },
    // 车辆
    {
      icon: 'el-icon-s-help',
      name: 'car',
      path: '/vehicle',
      component: () => import('@/pages/business/vehicle')
    },
    // 冷库
    {
      icon: 'el-icon-s-cooperation',
      name: 'refrigeratory',
      path: '/refrigeratory',
      component: () => import('@/pages/business/refrigeratory')
    },
    // 仓库
    {
      icon: 'icon-cangkukucun',
      name: 'warehouse',
      path: '/warehouse',
      component: () => import('@/pages/business/warehouse')
    },
    {
      icon: 'icon-dianpu',
      name: 'store',
      path: '/store',
      component: () => import('@/pages/business/store.vue')
    },
    {
      icon: '',
      name: 'other',
      path: '/other',
      component: () => import('@/pages/business/other.vue')
    },
    // 载体详情页
    {
      name: 'CarrierDetail',
      path: '/carrierDetailPage',
      hidden: true,
      component: () => import('@/pages/business/components/Detail.vue')
    }
  ]
}

export default carrier
